import { Component, OnInit, Inject,OnDestroy,ViewEncapsulation } from '@angular/core';
import { ResidentService } from '../../resident.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA} from '@angular/material';
import { MatDialogRef, MatDialog} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription, Subject } from 'rxjs';
import { ResidentGroupForCreation,ResidentGroupForCreationResponse} from '../../resident';
import { ApiService } from '../../../../api.service';
import { GroupNamefoundResponse, checkGroupName } from '../../../../api';
import { RollbarService } from '../../../../rollbar';
import * as Rollbar from 'rollbar';
import { SessionCheck,generateAlertMessage,AuthFailedMessage } from '../../../../app-general';
import {Router} from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { HostListener } from "@angular/core";
import { appsettings } from '../../../../app-settings';

@Component({
  selector: 'app-add-resident-group',
  templateUrl: './add-resident-group.component.html',
  providers: [ ResidentService ],
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./add-resident-group.component.scss']
})
export class AddResidentGroupComponent implements OnInit,OnDestroy {

  public residentGroupCreationForm : FormGroup;
  watcher: Subscription;
  columns: number = 3;
  groupdetails;
  groupresrowHeight = "67px";  
  residentgroupbool : boolean = true; 
  SiteId = "1";
  private _onDestroy: Subject<void> = new Subject<void>();
  constructor(private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<AddResidentGroupComponent>, @Inject(MAT_DIALOG_DATA) public data: string,
  private residentService: ResidentService,@Inject(RollbarService) private rollbar: Rollbar,private apiService: ApiService,public dialog: MatDialog) {
    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      if (change) {       
        if (change.mqAlias == 'xs') {
          this.columns = 2;
        } 
        else if (change.mqAlias == 'sm') {
          this.columns = 3;
        }         
        else {
          this.columns = 3;
        }
      }
    });
  }

  ngOnInit() {
    this.onResize();
    this.residentGroupCreationForm = new FormGroup({
      groupname: new FormControl('',[Validators.required, Validators.maxLength(30),Validators.pattern(appsettings.Name_Pattern)]),
      description:new FormControl('',[Validators.required, Validators.maxLength(150), Validators.pattern(appsettings.Name_Pattern)]),
     });
  } 
  
  handleInput(event) 
  {
    try
    {
      var n = event.target.value.lastIndexOf(" ");
      var l = event.target.value.length;
      var changedValue = event.target.value;
      if (event.which == 32 && changedValue.trim().length == 0) {
        changedValue = changedValue.trim();
      }
      else if (event.which == 32) {
        if (n + 1 == l) {
          changedValue = changedValue.trim() + " ";
        }
        else {
          changedValue = changedValue.trim();
        }
      }
      Object.keys(this.residentGroupCreationForm.controls).forEach(field => { // {1}
        const control = this.residentGroupCreationForm.get(field); // {2}
        if (field == document.getElementById(event.target.id).getAttribute("formControlName")) {
          control.setValue(changedValue);
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }
    catch(err) 
    {
      throw new Error('add-staff.component.ts' + ' - handleInput() - ' + err.message);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {    
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent)         
     if(isIEOrEdge == true)
     {       
       this.groupresrowHeight = "72.5px";
     }     
  }
  public onCloseCancel = () => {
   
    this.thisDialogRef.close('Cancel');
    if(!SessionCheck(this.router))
    {
        return;
    }
  }
  public hasError = (controlName: string, errorName: string) =>{
    return this.residentGroupCreationForm.controls[controlName].hasError(errorName);
  }
  public createResidentGroup = (ResidentgroupFormValue) => {  
    try
    {  
      if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
          return;
      }
      (document.activeElement as HTMLTextAreaElement).blur();
      if (this.residentGroupCreationForm.valid && this.residentgroupbool) {   
        this.residentgroupbool = false;
        var groupnamefoundItem : checkGroupName = 
        {
          siteId:this.SiteId, 
          authKey: localStorage.getItem("Authkey"),
          groupType: 1, 
          newGroupName: ResidentgroupFormValue.groupname.toString(), 
          groupId: 0 
        }
        this.apiService.checkGroupName(groupnamefoundItem).pipe(takeUntil(this._onDestroy))
        .subscribe((apiresponse : GroupNamefoundResponse[])=>{        
          if(apiresponse.toString() == "not found")
          {
            this.addResidentGroup(ResidentgroupFormValue);
          }
          else
          {
            this.residentgroupbool = true;          
            generateAlertMessage(this.dialog, "Resident Group name '" + apiresponse[0].name + "' already exists")
            return;
          }
        });
      }
   }
  catch (err) {
    throw new Error('add-resident-group.component.ts' + ' - createResidentGroup() - ' + err.message);
  }
}

  // Add Resident Group
  private addResidentGroup = (ResidentgroupFormValue) => {
    
    try
    {                        
         let addResidentgroup: ResidentGroupForCreation = {           
          authKey: localStorage.getItem("Authkey"),        
          groupname : ResidentgroupFormValue.groupname.replace(/\s+/g, ' ').trim(),
          description: ResidentgroupFormValue.description.replace(/\s+/g, ' ').trim()
         }         
          this.residentService.addResidentGroup(addResidentgroup).pipe(takeUntil(this._onDestroy))
           .subscribe((apiresponse : ResidentGroupForCreationResponse[])=>{                
              if(apiresponse["apiReturn"] == "Success")
              { 	
                this.residentgroupbool = false;
                generateAlertMessage(this.dialog, 'Resident group added successfully.')               
              }
              else if(apiresponse["apiReturn"] == "Fail")
              {
                this.residentgroupbool = true;
                generateAlertMessage(this.dialog, 'Resident group added failed.')                
              }
              else if(apiresponse["apiReturn"] == "Invalid Auth Key")
              {    
                  this.thisDialogRef.close('close');              
                  AuthFailedMessage(this.dialog,this.router);  
                  return;       
              } 
              this.thisDialogRef.close('Confirm');  
           });
      
           
    }
    catch (err) {
      throw new Error('add-resident-group.component.ts' + ' - addResidentGroup() - ' + err.message);
    }   
       }

 ngOnDestroy() {
	this._onDestroy.next();
	this._onDestroy.complete();
}
}
